import React, { PureComponent } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { FormattedMessage, injectIntl, type IntlShape } from 'react-intl';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import LimitationsNotification
  from 'components/pages/manage-family-page/limitations-notification/limitations-notification';
import DropFamilySection from 'components/shared/drop-family/drop-family-section/drop-family-section';

import PageTitle from 'components/shared/page-title/page-title';

import {
  inviteFamilyMember, resendInvite, removeFamilyMember,
} from 'state/family-plan/family-plan-actions';
import {
  getFamilyPlan, getFamilyMembersExceptCurrent, isFamilyFetched, isFamilyFull,
} from 'state/root-reducer';
import { showModal } from 'state/modal/modal-reducer';

import { showDangerNotification, showSuccessNotification } from 'state/notifier/notifier-reducer';

import analytics, { events } from 'utils/analytics';
import MembersList from './members-list/members-list';

import './activated-family-plan.scss';


const mapStateToProps = (state) => ({
  members: getFamilyMembersExceptCurrent(state),
  isFamilyProcessing: getFamilyPlan(state).isLoading,
  isFamilyFetched: isFamilyFetched(state),
  isFamilyFull: isFamilyFull(state),
  familySeats: getFamilyPlan(state).seats,
  familyPricePlan: getFamilyPlan(state).price,
});

const mapActionsToProps = {
  //TODO: remove inviteFamilyMember resendInvite removeFamilyMember actions
  inviteFamilyMember,
  resendInvite,
  removeFamilyMember,
  showModal,
  showDangerNotification,
  showSuccessNotification,
};

const connector = connect(mapStateToProps, mapActionsToProps);

type Props = ConnectedProps<typeof connector> & {
  intl: IntlShape;
};

class ActivatedFamilyPlan extends PureComponent<Props> {
  validation = {
    email: {
      required: <FormattedMessage id="activatedFamilyPlan.validation.emptyEmail" defaultMessage="Email is required" />,
      emailFormat: <FormattedMessage id="activatedFamilyPlan.validation.invalidEmail" defaultMessage="Invalid email" />,
    },
  };

  render() {
    const {
      members, familyPricePlan,
    } = this.props;

    return (
      <div>
        <PageTitle>
          <FormattedMessage id="activatedFamilyPlan.pageTitle" defaultMessage="My Setapp Family" />
        </PageTitle>
        <Row>
          <LimitationsNotification />
        </Row>
        <Row>
          <Col lg={6}>
            {Boolean(members.length) && (
              <MembersList
                members={members}
              />
            )}
            <DropFamilySection
              familyPricePlan={familyPricePlan}
              onDropFamilyClick={this.showDropFamilyModal}
            />
          </Col>
        </Row>
      </div>
    );
  }

  showDropFamilyModal = () => {
    const { showModal } = this.props;

    showModal('DROP_FAMILY');

    analytics.trackEvent(events.FAMILY_PLAN_DROP_CLICK, {
      eventLabel: 'Family page',
    });
  };
}

export { ActivatedFamilyPlan as PureActivatedFamilyPlan };

export default connector(injectIntl(ActivatedFamilyPlan));
